module.exports = __webpack_public_path__ + "img/Avartar].97f157bf.png";